var d = Object.defineProperty,
  B = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty,
  n = Object.prototype.propertyIsEnumerable;
var i = (o, e, r) => e in o ? d(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : o[e] = r,
  a = (o, e) => {
    for (var r in e || (e = {})) l.call(e, r) && i(o, r, e[r]);
    if (t) for (var r of t(e)) n.call(e, r) && i(o, r, e[r]);
    return o;
  },
  c = (o, e) => B(o, z(e));
var m = (o, e) => {
  var r = {};
  for (var p in o) l.call(o, p) && e.indexOf(p) < 0 && (r[p] = o[p]);
  if (o != null && t) for (var p of t(o)) e.indexOf(p) < 0 && n.call(o, p) && (r[p] = o[p]);
  return r;
};
import * as x from "react";
import { Box as S, safelySpreadBoxProps as W } from "@twilio-paste/box";
const f = x.forwardRef((w, P) => {
  var s = w,
    {
      as: o = "span",
      color: e = "currentColor",
      display: r = "block",
      element: p = "ICON",
      size: y = "sizeIcon30"
    } = s,
    I = m(s, ["as", "color", "display", "element", "size"]);
  return x.createElement(S, c(a({}, W(I)), {
    as: o,
    element: p,
    lineHeight: "lineHeight0",
    display: r,
    color: e,
    size: y,
    ref: P
  }));
});
f.displayName = "IconWrapper";
export { f as IconWrapper };